import React from 'react';

interface IndexColumnProps {
  value: number;
}

export default React.memo((props: IndexColumnProps) => {
  return <>{props.value + 1}</>;
});
